import removeDuplicates from './Removeduplicates'
import createStringDiv from './CreateStringDiv'
import createButton from './CreazioneBottoni'
//import RealTime from './CreazioneRealTime'
//import axios from 'axios'
import removeOldLayer from './RemoveOldLayer'
import L from "leaflet";
/*
import left from './left.svg'
import right from './right.svg'
import startImage from './green.svg'
import endImage from './red.svg'
import OvalStart from './OvalStart.png'
import OvalEnd from './OvalEnd.png'
import start1 from './start1.svg'
import finish1 from './finish1.svg'
import CreazioneBottoniFrecce from './CreazioneBottoniFrecce'*/
import './ClickOnMap.css'
import i18n from 'i18next';
import start from './start.png'
import finish from './finish.png'
import info from './info.png'
import copy from './copy.png'


var container = L.DomUtil.create('div','custom')
container.id = "popupContainer"
// Creazione del popup
const createDiv = (data, latlng, props, map) => {
  //const [partenza,setPartenza] = React.useState();


 // var contatore = 0

  //var layerNames = ["Fermate TPL", "Aeroporti", "Porti", "Stazioni Ferroviarie", "Comuni", "Zone Tariffarie"]

  container.innerHTML = ""
  container.innerHTML += `<div class="superiorDiv"><p1 class="infoText">` + i18n.t("Punto selezionato") + `</p1></div>` //TRADUCI

  //document.getElementById("loadingPopup").innerHTML.style.display = "none";
  var div = L.DomUtil.create('div', '', container)

  div.className = "informationPopUp"
  //div.innerHTML += `<div></div>` 

  const createLayerDivInformation = (layer) => {

    var dati = createStringDiv(layer, latlng)


    try {

      if(dati) {
        let result = dati
       
        //if (result != undefined) 
        // div.innerHTML = result.value

        props.changeLayerInformation(result.value)

        div.innerHTML = ""
        //if (layer.nome === "Fermate TPL" || "Aeroporti" || "Porti" || "Stazioni Ferroviarie") {
        //if (layerNames.includes(layer.nome)) {
          container.innerHTML = `<div class="superiorDiv"><p1 class="infoText">${i18n.t(layer.nome)}</p1></div>` //AGGIUNTO
          div = L.DomUtil.create('div', '', container)        
          div.className = "informationPopUp"
          //div.innerHTML += layer.nome
          
          div.innerHTML += `<img src=${copy} id='copia' onclick='navigator.clipboard.writeText("${result.coordinate.latitudine},${result.coordinate.longitudine}");alert("${i18n.t('Coordinate copiate')}")'></img>`
          if(result.id !== undefined && result.id !== "") div.innerHTML += "ID: " + result.id + "<br>"
          if(result.fermata !== undefined) div.innerHTML += result.fermata
          //div.innerHTML += `<br><button class="fermateRealTimeButton">${i18n.t("Informazioni")}</button>` 
          //div.onclick = () => { props.changeLayerDrawer(true) }
        //}
        //creazione button per info laterali
        const infoBtn = createButton(info, container, i18n.t("INFO"))
        infoBtn.className = "infoButtonPopUp"
        L.DomEvent.on(infoBtn, 'click', () => {props.changeLayerDrawer(true) });

        //creazione button per prendere nome e coordinate dei layer
        const startBtn = createButton(start, container, i18n.t("Parti da qui"))
        startBtn.className = "startButtonPopUp"
         L.DomEvent.on(startBtn, 'click', () => {
          //if (result.coordinate.latitudine !== undefined && result.fermata !== undefined) {
          //props.changeRegioneAereoPartenza(result.regione)
          let point = { description: `${result.fermata}`, lat: `${result.coordinate.latitudine}`, lng: `${result.coordinate.longitudine}` }
          props.changeNomeFermataStart(result.fermata)
          props.changePositionTariffaStart(point)
          props.changepositionStart(point)
          //} else { props.changepositionStart(`${latlng.lat},${latlng.lng}`) }          
          let latlng = { lat: parseFloat(result.coordinate.latitudine).toFixed(14), lng: parseFloat(result.coordinate.longitudine).toFixed(14) }          
          props.markerStart2(latlng)          
          removeOldLayer(map);
          //setTimeout(document.getElementsByClassName("buttonStyle")[0].click(), 500)
          //setTimeout(document.getElementById("calcolaButton").click(),500)
        }); 

        //Button end
        const endBtn = createButton(finish, container, i18n.t("Arriva qui"))
        endBtn.className = "endButton"
         L.DomEvent.on(endBtn, 'click', () => {
          //props.changeRegioneAereoArrivo(result.regione)
          let point = { description: `${result.fermata}`, lat: `${result.coordinate.latitudine}`, lng: `${result.coordinate.longitudine}` }
          props.changeNomeFermataEnd(result.fermata)
          props.changePositionTariffaEnd(point)
          props.changepositionEnd(point)          
          let latlng = { lat: parseFloat(result.coordinate.latitudine).toFixed(14), lng: parseFloat(result.coordinate.longitudine).toFixed(14) }
          props.markerEnd2(latlng)         
          removeOldLayer(map);
          //setTimeout(document.getElementById("calcolaButton").click(),500)
        }); 
      }

    } catch (error) {
      console.log(error)
    }

  }



  const drawImage = (image) => {

    var iconStart = L.icon({
      iconUrl: image,
      iconSize: [30, 30],
      iconAnchor: [15, 35],
      popupAnchor: [0, -35]
    });
    return iconStart
  }

  // Button Plus Layer
  //const layerPlus = CreazioneBottoniFrecce(right, container,"")
  //layerPlus.className = "layerPlus"

  // Evento Click
  /* L.DomEvent.on(layerPlus, 'click', () => {
    if (contatore<layerData.length - 1){
      contatore +=1
      createLayerDivInformation(layerData[contatore])
    
              
    }
  }) */

  //Button Minus layer
  // const layerMinus = CreazioneBottoniFrecce(left, container,"")
  // layerMinus.className = "layerMinus"

  // Evento Click
  /* L.DomEvent.on(layerMinus, 'click', () => {
      if (contatore>0){
          contatore -=1
          createLayerDivInformation(layerData[contatore])
        
      }
  }) */

  // Creazione informazione primo layer
  const layerData = removeDuplicates(data)
  //const layerData = data;
 
  if (layerData.length === 0) {

    div.innerHTML += `<img src=${copy} id='copia' onclick='navigator.clipboard.writeText("${latlng.lat},${latlng.lng}");alert("${i18n.t('Coordinate copiate')}")'></img>`

    div.innerHTML += ' Latitudine : ' + latlng.lat.toFixed(6) + '<br> Longitudine : ' + latlng.lng.toFixed(6)    
    //creazione dei button

     const startBtn = createButton(start, container, i18n.t("Parti da qui"))
    startBtn.className = "startButtonPopUp"


    L.DomEvent.on(startBtn, 'click', () => {   
      let description = `${latlng.lat.toFixed(8)},${latlng.lng.toFixed(8)}`
      let point = { description: description, lat: `${latlng.lat.toFixed(8)}`, lng: `${latlng.lng.toFixed(8)}` }
      props.changeNomeFermataStart(description)
      props.changepositionStart(point)
      props.changePositionTariffaStart(point)
      props.markerStart2(latlng)
      removeOldLayer(map);
      //setTimeout(document.getElementById("calcolaButton").click(),500)
    }); 


    //Button end
    const endBtn = createButton(finish, container, i18n.t("Arriva qui"))
    endBtn.className = "endButton"
    L.DomEvent.on(endBtn, 'click', () => {
      let description = `${latlng.lat.toFixed(8)},${latlng.lng.toFixed(8)}`
      let point = { description: description, lat: `${latlng.lat.toFixed(8)}`, lng: `${latlng.lng.toFixed(8)}` }
      props.changeNomeFermataEnd(description)
      props.changepositionEnd(point)      
      props.changePositionTariffaEnd(point)
      props.markerEnd2(latlng)      
      removeOldLayer(map);
      //setTimeout(document.getElementById("calcolaButton").click(),500)
    });
 
  } else if (layerData.length > 0) {
    div.innerHTML += createLayerDivInformation(layerData[0])

  }

  if (props.changeLayerDiv) props.changeLayerDiv(div)
  
  return container
}



export default createDiv

